import { useEffect, useState } from 'react';
import CopyIcon from '../../../assets/icons/mfa/copyIcon.svg?react';
import CheckFilled from '../../../assets/icons/mfa/checkFilled.svg?react';

type CopyButtonProps = {
  valueToBeCopied: string;
  showText?: boolean;
};

const CopyButton = ({
  valueToBeCopied,
  showText = true,
  ...otherProps
}: CopyButtonProps) => {
  const [copySuccess, setCopySuccess] = useState<boolean>(false);

  useEffect(() => {
    setTimeout(() => {
      if (copySuccess) {
        setCopySuccess(false);
      }
    }, 3000);
  }, [copySuccess]);

  const handleCopyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(valueToBeCopied);
      setCopySuccess(true);
    } catch (error) {
      setCopySuccess(false);
      console.error('Error copying text to clipboard:', error);
    }
  };

  return (
    <div onClick={handleCopyToClipboard} {...otherProps}>
      {copySuccess ? (
        <CheckFilled fill="var(--color-black-700)" />
      ) : (
        <CopyIcon stroke="var(--color-black-600)" />
      )}
    </div>
  );
};

export default CopyButton;
